<template>
<div style="height:1920px; width:1080px">
    <transition>
    <div v-if="this.language == 1 && this.current == 0" class="home-lv slide">
        <div style="line-height:1.5;position:absolute; background-color:rgba(203,196,192, .80); font-size:31px;padding:20px;font-family:'Century Schoolbook'; color:rgb(91,91,91); font-weight:bold; width:800px;top:275px; left:140px;  text-align:center; text-transform:uppercase">Nacionālā identitāte <br> kultūras notikumos un  tēlos
        </div>

        <div style="position:absolute; background-color:rgba(203,196,192, .80); 
        font-size:18px;padding:20px;font-family:'Century Schoolbook'; color:rgb(91,91,91);  width:380px;top:580px; left:350px; text-align:center;  line-height:1.5">
            <img src="../assets/zimes/top-qoutes.png" style="position:absolute; left:10px; top:10px;">
            Vēl Latvija tik garā veidojās, <br>
            Kad dailes pils jau pirmā pacēlās <br>
            /Aspazija/
            <img src="../assets/zimes/bottom-qoutes.png" style="position:absolute; right:10px; bottom:10px;">

        </div>
        <div style="height:100vh;">
            <div class="home-arrow">
                <img src="../assets/zimes/start.png" @click="slide(1)" class="animated animated pulse infinite slow"
                    alt="">
            </div>
            
        </div>
    </div>
    <div v-if="this.language == 2 && this.current == 0" class="home-lv slide">
       <div style="line-height:1.5;position:absolute; background-color:rgba(203,196,192, .80); font-size:31px;padding:20px;font-family:'Century Schoolbook'; color:rgb(91,91,91); font-weight:bold; width:800px;top:275px; left:140px;  text-align:center; text-transform:uppercase">National identity in <br> cultural events and images
        </div>
        <div style="height:100vh;">
            <div class="home-arrow">
                <img src="../assets/zimes/start.png" @click="slide(1)" class="animated animated pulse infinite slow"
                    alt="">
            </div>
        </div>
    </div>
    </transition>
    <!-- Latviešu valoda -->
    <div v-if="this.language == 1 && this.current == 1" class="slide slide-1" style="position:relative">
            <div  class="img-slider">
                
                <div style="width:100%; height:317px;background:rgba(203,196,192, 1); padding-top:10px;">
                    <div style="position:relative;height:100%;">
                    <Slick :options="slht">
                    

                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (1).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (10).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (11).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (12).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (13).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (14).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (15).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (16).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (17).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (18).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (19).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (2).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (20).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (21).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (22).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (23).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (24).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (25).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (26).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (27).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (28).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (29).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (3).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (30).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (31).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (32).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (33).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (34).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (35).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (36).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (37).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (38).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (39).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (4).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (40).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (41).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (42).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (43).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (44).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (45).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (46).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (47).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (48).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (49).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (5).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (50).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (51).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (52).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (53).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (54).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (55).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (56).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (57).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (58).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (59).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (6).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (60).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (61).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (62).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (63).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (64).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (7).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (8).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (9).jpg' /></div>



                        
                    </Slick>
                    </div>
                </div>
            </div>
            
            
             <div style="width:100%; height:1290px;position:relative" >
                 <transition name="fade">
                 <div v-if="subcat==false">
                     <div style="position:absolute; top:150px; left:250px" @click="pop1=true">
                    <div class="category cat-1 animated pulse infinite slow">
                        
                        <h3>Latviešu Etnogrāfiskā izstāde </h3>
                    </div>

                </div>


                <div style="position:absolute; top:530px; left:250px" @click="pop2=true">
                    <div class="category cat-2 animated pulse infinite slow">
                        
                        <h3>III–V Vispārīgie latviešu Dziesmu svētki </h3>
                    </div>

                </div>

                <div style="position:absolute; top:900px; left:250px" @click="pop3=true">
                    <div class="category cat-3 animated pulse infinite slow">
                        
                        <h3>Arhitektūra – nacionālā romantisma stils </h3>
                    </div>

                </div>


                <div style="position:absolute; top:150px; right:250px" @click="subcat=true">
                    <div class="category cat-4 animated pulse infinite slow">
                        
                        <h3>Nacionālās identitātes atspoguļojums  latviešu tēlotājā mākslā</h3>
                    </div>

                </div>

                <div style="position:absolute; top:530px; right:250px" @click="pop5=true">
                    <div class="category cat-5 animated pulse infinite slow">
                        
                        <h3>Heroisms un ētiskās vērtības latviešu teātrī </h3>
                    </div>

                </div>
                <div style="position:absolute; top:900px; right:250px" @click="pop6=true">
                    <div class="category cat-6 animated pulse infinite slow">
                        
                        <h3>Latviešu grāmatniecība un kartogrāfija  </h3>
                    </div>

                </div>


                 </div>
                 </transition>
                 <transition name="fade">
                 <div v-if="subcat==true">
                 <div style="position:absolute;top:50px;right:50px;">
                    <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="subcat=false">
                </div>
                <div style="position:absolute; top:150px; left:250px" @click="pop7=true">
                    <div class="category cat-7 animated pulse infinite slow">
                        
                        <h3>IV Latviešu mākslinieku izstāde</h3>
                    </div>

                </div>


                <div style="position:absolute; top:430px; left:250px" @click="pop8=true">
                    <div class="category cat-8 animated pulse infinite slow">
                        
                        <h3>Zemnieku portreti un darbi</h3>
                    </div>

                </div>

                <div style="position:absolute; top:700px; left:250px" @click="pop9=true">
                    <div class="category cat-9 animated pulse infinite slow">
                        
                        <h3>Latvijas daba</h3>
                    </div>

                </div>


                <div style="position:absolute; top:970px; left:250px" @click="pop10=true">
                    <div class="category cat-10 animated pulse infinite slow">
                        
                        <h3>Kultūrvaronis</h3>
                    </div>

                </div>

                <div style="position:absolute; top:150px; right:250px" @click="pop11=true">
                    <div class="category cat-11 animated pulse infinite slow">
                        
                        <h3>Latviešu ornamenta modernizācija  </h3>
                    </div>

                </div>
                <div style="position:absolute; top:430px; right:250px" @click="pop12=true">
                    <div class="category cat-12 animated pulse infinite slow">
                        
                        <h3>Folklora un mitoloģija</h3>
                    </div>

                </div>
                <div style="position:absolute; top:700px; right:250px" @click="pop13=true">
                    <div class="category cat-13 animated pulse infinite slow">
                        
                        <h3>Vēsturiskais žanrs</h3>
                    </div>

                </div>
                <div style="position:absolute; top:970px; right:250px" @click="pop14=true">
                    <div class="category cat-14 animated pulse infinite slow">
                        
                        <h3>Tēlniecība</h3>
                    </div>

                </div>
                </div>
                 </transition>
            </div>

            <div style="width:100%; height:342px;overflow:visible">

                <swiper :options="swipperOptions">

                    <swiper-slide>
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:260px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:485px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:710px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:985px" />
                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">
                        <div style="position:absolute; bottom:65px; left:115px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop1 = !tpop1">1886</p>
                                <transition name="fade">
                                    <div v-if="this.tpop1 == true" class="description">Rīgā sāk iznākt laikraksts “Dienas Lapa”
                                        (1886–1905 un 1913–1914), kopš 1890. gadu sākuma – Jaunās strāvas ideju galvenais paudējs
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:340px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop2 = !tpop2">1888</p>
                                <transition name="fade">
                                    <div v-if="this.tpop2 == true" class="description">Notiek III Vispārīgie latviešu dziedāšanas
                                        svētki</div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:565px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop3 = !tpop3">1891</p>
                                <transition name="fade">
                                    <div v-if="this.tpop3 == true" class="description">
                                        <ul>
                                            <li>Pēterburgā nodibinās latviešu mākslinieku pulciņš “Rūķis”</li>
                                            <li>Jānis Pliekšāns (vēlākais dzejnieks Rainis) kļūst par laikraksta “Dienas Lapa”
                                                redaktoru</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:785px; width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop4 = !tpop4">1891 – 1903 </p>
                                <transition name="fade">
                                    <div v-if="this.tpop4 == true" class="description two">Anša Lerha-Puškaiša sakārtojumā iznāk
                                        "Latviešu tautas teikas un pasakas" 7 sējumos</div>
                                </transition>

                            </div>
                        </div>


                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:180px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:455px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:680px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:905px" />
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">
                        <div style="position:absolute; bottom:65px; left:-20px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop5 = !tpop5">1891 – 1898</p>
                                <transition name="fade">
                                    <div v-if="this.tpop5 == true" class="description two">Jēkaba Dravnieka apgādā Jelgavā iznāk
                                        pirmā Konversācijas vārdnīca latviešu valodā
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:255px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop6 = !tpop6">1894 – 1898</p>
                                <transition name="fade">
                                    <div v-if="this.tpop6 == true" class="description two">Iznāk “Latvju dainu” pirmie sējumi
                                    </div>
                                </transition>

                            </div>
                        </div>

                        <div style="position:absolute; bottom:65px; left:535px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop7 = !tpop7">1894</p>
                                <transition name="fade">
                                    <div v-if="this.tpop7 == true" class="description">
                                        <ul>
                                            <li>Sāk iznākt Andreja Jurjāna mūža darbs “Latvju tautas mūzikas materiāli” 6 burtnīcās
                                                – latviešu mūzikas folkloristikas pamats</li>
                                            <li>Aspazijas lugu “Vaidelote” un “Zaudētās tiesības” pirmuzvedums Rīgas Latviešu
                                                teātrī</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:760px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop8 = !tpop8">1895</p>
                                <transition name="fade">
                                    <div v-if="this.tpop8 == true" class="description">
                                        <ul>
                                            <li>Notiek IV Vispārīgie latviešu Dziesmu un Mūzikas svētki</li>
                                            <li>Iznāk Kārļa Mīlenbaha “Latviešu valodas mācība”</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>


                    </swiper-slide>
                    <swiper-slide>
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:50px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:275px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:500px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:775px" />
                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">
                        <div style="position:absolute; bottom:65px; left:-95px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop9 = !tpop9">1896</p>
                                <transition name="fade">
                                    <div v-if="this.tpop9 == true" class="description">Rīgā atklāta Latviešu etnogrāfiskā izstāde</div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:130px; width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop10 = !tpop10">1899</p>
                                <transition name="fade">
                                    <div v-if="this.tpop10 == true" class="description">Jāzeps Vītols sacer kora dziesmu “Gaismas
                                        pils” ar Ausekļa vārdiem</div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:355px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop11 = !tpop11">1902</p>
                                <transition name="fade">
                                    <div v-if="this.tpop11 == true" class="description">
                                        <ul>
                                            <li>Rūdolfa Blaumaņa lugas “Skroderdienas Silmačos” pirmuzvedums Rīgas Latviešu teātrī</li>
                                            <li>Sāk iznākt Emiļa Melngaiļa tautas dziesmu apdares “Birzēs i norās”</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:575px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop12 = !tpop12">1903 – 1915</p>
                                <transition name="fade">
                                    <div v-if="this.tpop12 == true" class="description two">
                                        Iznāk “Latvju dainu” pārējie pieci sējumi
                                    </div>
                                </transition>

                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:-75px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:150px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:375px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:600px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:825px" />
                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">

                        <div style="position:absolute; bottom:65px; left:-220px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop13 = !tpop13">1903</p>
                                <transition name="fade">
                                    <div v-if="this.tpop13 == true" class="description">
                                        <ul>
                                            <li>Jāzeps Vītols sacer kora dziesmu “Karaļmeita” ar Raiņa vārdiem</li>
                                            <li>Annas Brigaderes lugas “Sprīdītis” pirmuzvedums Rīgas Latviešu teātrī</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:5px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop14 = !tpop14">1904</p>
                                <transition name="fade">
                                    <div v-if="this.tpop14 == true" class="description">
                                        <ul>
                                            <li>Emīls Dārziņš sacer kora dziesmu “Senatne” ar Raiņa vārdiem</li>
                                            <li>Rūdolfa Blaumaņa lugas “Indrāni” pirmuzvedums Rīgas Latviešu teātrī</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:230px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop15 = !tpop15">1905</p>
                                <transition name="fade">
                                    <div v-if="this.tpop15 == true" class="description">
                                        <ul>
                                            <li>Aspazijas lugas “Sidraba šķidrauts” pirmuzvedums Jaunajā Rīgas Latviešu teātrī</li>
                                            <li>Tiek nodibināta Rīgas Latviešu biedrības Zinību komisijas Vēstures nodaļa</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:455px; width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop16 = !tpop16">1906</p>
                                <transition name="fade">
                                    <div v-if="this.tpop16 == true" class="description">
                                        <ul>
                                            <li>Rīgā atver Pilsētas mākslas muzeju (tagadējo Latvijas Nacionālo Mākslas muzeju)</li>
                                            <li>Mārtiņš Buclers nodibina Latviešu Fotogrāfisko biedrību</li>
                                            <li>Rīgā sāk darboties Jāņa Misiņa bibliotēka – tolaik vecākā un pilnīgākā latviešu
                                                grāmatu krātuve</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:680px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop17 = !tpop17">1908</p>
                                <transition name="fade">
                                    <div v-if="this.tpop17 == true" class="description">
                                        <ul>
                                            <li>Rīgas Latviešu biedrības ortogrāfijas komisija valodnieku Kārļa Mīlenbaha un Jāņa
                                                Endzelīna vadībā pamatos izveido mūsdienu latviešu ortogrāfiju</li>
                                            <li>Dibināts Jaunais Rīgas teātris</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>


                    </swiper-slide>

                    <swiper-slide>
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:-30px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:200px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:420px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:645px" />

                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">
                        <div style="position:absolute; bottom:65px; left:-175px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop18 = !tpop18">1909</p>
                                <transition name="fade">
                                    <div v-if="this.tpop18 == true" class="description">
                                        <ul>
                                            <li>Atklāta Rīgas Latviešu biedrības jaunā ēka</li>
                                            <li>Sāk darboties J. Dubura un Zeltmata dramatiskie kursi – pirmā profesionālās
                                                aktiermākslas studija latviešu teātra vēsturē</li>
                                            <li>Iznāk Raiņa dzejoļu krājums “Klusā grāmata”</li>
                                            <li>Raiņa lugas “Zelta zirgs” pirmiestudējums Jaunajā Rīgas teātrī</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:50px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop19 = !tpop19">1910</p>
                                <transition name="fade">
                                    <div v-if="this.tpop19 == true" class="description">
                                        <ul>
                                            <li>V Vispārējie latviešu Dziesmu svētki</li>
                                            <li>Tiek sarīkota pirmā plašākā latviešu tēlotājas mākslas darbu izstāde</li>
                                            <li>Iznāk Raiņa dzejoļu krājums “Ave sol!”</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:275px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop20 = !tpop20">1911</p>
                                <transition name="fade">
                                    <div v-if="this.tpop20 == true" class="description">
                                        <ul>
                                            <li>Sāk darboties Latviešu mākslas veicināšanas biedrība</li>
                                            <li>Rīgā baletmeistara Mārtiņa Kauliņa vadībā sāk darboties pirmā pastāvīgā latviešu
                                                baleta trupa</li>
                                            <li>Raiņa lugas “Uguns un nakts” pirmiestudējums Jaunajā Rīgas teātrī</li>
                                            <li>Sāk iznākt latviešu dienas laikraksts “Jaunākās Ziņas” – vēlākos gados lielākais
                                                latviešu periodiskais izdevums (izdevēji Antons un Emīlija Benjamiņi)</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:500px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop21 = !tpop21">1912</p>
                                <transition name="fade">
                                    <div v-if="this.tpop21 == true" class="description">
                                        <ul>
                                            <li>Raiņa lugas “Indulis un Ārija” pirmiestudējums Jaunajā Rīgas teātrī</li>
                                            <li>Tiek dibināta Latviešu opera</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:725px; width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop22 = !tpop22">1914</p>
                                <transition name="fade">
                                    <div v-if="this.tpop22 == true" class="description">
                                        Raiņa lugas “Pūt, vējiņi!” pirmiestudējums Jaunajā Rīgas teātrī
                                    </div>
                                </transition>

                            </div>
                        </div>



                    </swiper-slide>



                </swiper>
            </div>

            <transition name="fade">
                <div v-if="pop1 == true" class="pop-slider" style="z-index:50;position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;" >
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop1=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                            <div>
                                <div class="prev">
                                    
                                </div>
                                <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (1).jpg' />
                                <p class="annotation">Latviešu Etnogrāfiskās izstādes plakāts. 1896 </p>
                                </div>
                                <div class="next">
                                    <img src="../assets/zimes/next.png" alt="">
                                </div>
                            </div>
                            <div >
                                <div class="prev">
                                    <img src="../assets/zimes/prev.png" alt="">
                                </div>
                                <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (2).jpg' />
                                <p class="annotation">Konstantīns Pēkšēns. Latviešu Etnogrāfiskās izstādes ēka. 1896 </p>
                                </div>
                                <div class="next">
                                    
                                </div>
                            </div>
                            
                    </Carousel>

                </div>
            </transition>


            <transition name="fade">
                <div v-if="pop2 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop2=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">
                               
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (3).jpg' />
                                <p class="annotation">Rīgas Latviešu dziedāšanas biedrības jauktais koris – galvenās balvas
                                    ieguvējs
                                    III Vispārīgajos latviešu Dziedāšanas svētkos. 1888
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>

                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (4).jpg' />
                                <p class="annotation">Rihards Zariņš. IV Vispārīgo latviešu Dziesmu un mūzikas svētku afiša. 1895
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>

                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (5).jpg' />
                                <p class="annotation">Skats uz V Vispārējo latviešu Dziesmu svētku ēku. Arhitekts Ernests Pole.
                                    1910. LNVM </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (6).jpg' />
                                <p class="annotation">Dziesmu svētku gājiens. Rīga. 1910. </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (7).jpg' />
                                <p class="annotation">Dziesmu svētku ēkas iekšskats. </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>
                    </Carousel>

                </div>
            </transition>
       
    


            <transition name="fade">
                <div v-if="pop3 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop3=false">
                    </div>
                    <!-- 7-18 -->
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (10).jpg' />
                                <p class="annotation">Konstantīns Pēkšēns un Eižens Laube. Īres nams Rīgā, Aleksandra Čaka ielā 26.
                                    <br>20. gadsimta sākums</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:10px 5px;' src='../assets/images/img (11).jpg' />

                                <img style='padding:0 5px;' src='../assets/images/img (12).jpg' />

                                <p class="annotation">Konstantīns Pēkšēns un Eižens Laube. Īres nams Rīgā, Aleksandra Čaka ielā 26.
                                    Fragmenti </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px; width:50%;margin:auto !important' src='../assets/images/img (13).jpg' />
                                <p class="annotation">Konstantīns Pēkšēns un Eižens Laube. Ata Ķeniņa ģimnāzija Tērbatas ielā 15.
                                    1905 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (14).jpg' />
                                <p class="annotation">Eižens Laube. Īres nams Brīvības ielā 47. 1908. </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (15).jpg' />
                                <p class="annotation">Eižens Laube. Īres nams Brīvības ielā 47. 1908. Fragments. RJC. Foto Marika
                                    Vanaga </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (16).jpg' />
                                <p class="annotation">Eižens Laube. Īres nams Brīvības ielā 37. 1908. Fragments </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (17).jpg' />
                                <p class="annotation">Eižens Laube. Īres nams Brīvības ielā 62. 1908. Fragments. RJC. Foto Marika
                                    Vanaga </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (18).jpg' />
                                <p class="annotation">Eižens Laube. Īres nams Brīvības ielā 62. 1908 (uz portāla atšķirīgs
                                    gadaskaitlis – 1909). Fragments.RJC. Foto Marika Vanaga </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (19).jpg' />
                                <p class="annotation">Eižens Laube. Īres nams Ģertrūdes ielā 23/25. 1909</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (20).jpg' />
                                <p class="annotation">Aleksandrs Vanags. Īres nams Rīgā, Krišjāņa Valdemāra ielā 69. 1909</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (21).jpg' />
                                <p class="annotation">Aleksandrs Vanags. Īres nams Rīgā, Krišjāņa Valdemāra ielā 69. Fragments. RP
                                    KIA muzejs “Rīgas Jūgendstila centrs”. Foto Romvalds Salcevičs</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (22).jpg' />
                                <p class="annotation">Ernests Pole un Eižens Laube. Rīgas Latviešu biedrības nams. 1909</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (23).jpg' />
                                <p class="annotation">Janis Rozentāls. “Pērkons, Potrimps un Pīkols.” Rīgas Latviešu biedrības
                                    centrālais dekoratīvais panno. 1910.</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (24).jpg' />
                                <p class="annotation">Janis Rozentāls. “Skaistums. Saules sveiciens.” Rīgas Latviešu biedrības
                                    kreisā rizalīta dekoratīvais panno. 1910</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (25).jpg' />
                                <p class="annotation">Janis Rozentāls. “Pie avota.” Rīgas Latviešu biedrības labā rizalīta
                                    dekoratīvais panno. 1910</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (26).jpg' />
                                <p class="annotation">Augusts Malvess. Siguldas “Vidzemes Šveices” biedrības ēka. 1911</p>
                            </div>
                            <div class="next">

                            </div>
                        </div>
                    </Carousel>

                </div>
            </transition>
            

            <!-- subpops -->
            <transition name="fade">
            <div v-if="pop7 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;" >
                <div style="position:absolute;top:50px;right:50px; z-index:999">
                    <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop7=false">
                </div>
                <Carousel :items="1" :dots="false">
                        <div >
                            <img style='padding:0 5px;' src='../assets/images/img (45).jpg' />
                            <p class="annotation">Janis Rozentāls. IV latviešu mākslinieku izstādes plakāts. 1914 </p>
                        </div>
                       
                </Carousel>

            </div>
            </transition>

            <transition name="fade">
                <div v-if="pop8 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop8=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (27).jpg' />
                                <p class="annotation">Ādams Alksnis. “Tēva portrets.” Ap 1890 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (28).jpg' />
                                <p class="annotation">Ādams Alksnis. 1896. gada Latviešu Etnogrāfiskajai izstādei zīmētie zemnieku
                                    portreti </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (29).jpg' />
                                <p class="annotation">Janis Rozentāls. “Ganu meita.” 1896 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (30).jpg' />
                                <p class="annotation">Janis Rozentāls. “Siena laiks.” 1903 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (31).jpg' />
                                <p class="annotation">Janis Rozentāls. “No pļavas.” 1903 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (32).jpg' />
                                <p class="annotation">Janis Rozentāls. “Maizes mīcītāja.” 1896 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (33).jpg' />
                                <p class="annotation">Teodors Ūders. “Rīts.” Ap 1910 </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
                <div v-if="pop9 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop9=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (34).jpg' />
                                <p class="annotation">Vilhelms Purvītis. “Agrs pavasaris.” 1898 – 1899 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (35).jpg' />
                                <p class="annotation">Janis Rozentāls. “Pavasara ainava. Sigulda.” 1913 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (36).jpg' />
                                <p class="annotation">Vilhelms Purvītis. “Pavasara ūdeņi”" (“Maestoso”). 1910 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>

                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (38).jpg' />
                                <p class="annotation">Vilhelms Purvītis. “Rudens saule.” Ap 1909 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (39).jpg' />
                                <p class="annotation">Vilhelms Purvītis. “Ainava ar bērziem.” Ap 1910 </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
                <div v-if="pop10 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop10=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (40).jpg' />
                                <p class="annotation">Jānis Krēsliņš. Lāčplēsis. Ilustrācija grāmatai “Latviešu teikas iz
                                    Malienas”. 1891 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>

                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (41).jpg' />
                                <p class="annotation">Rihards Zariņš. Varonis Kurbads un deviņgalvainais velns. No cikla “Ko
                                    Latvijas
                                    meži šalc”. 1908 – 1911.
                                </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
            <div v-if="pop11 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;" >
                <div style="position:absolute;top:50px;right:50px; z-index:999">
                    <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop11=false">
                </div>
                <Carousel :items="1" :dots="false">
                        <div >
                            <img style='padding:0 5px;' src='../assets/images/img (42).jpg' />
                            <p class="annotation">Jūlijs Madernieks. Ornamenti un raksta paraugs. Ap 1913</p>
                        </div>
                       
                </Carousel>

            </div>
            </transition>

            <transition name="fade">
                <div v-if="pop12 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop12=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (37).jpg' />
                                <p class="annotation">Johans Valters. “Pavasaris" (“Bārenīte”). 1907. </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (46).jpg' />
                                <p class="annotation">Janis Rozentāls. “Melna čūska miltus mala.” 1903 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (47).jpg' />
                                <p class="annotation">Janis Rozentāls. “Teika.” 1899. </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (48).jpg' />
                                <p class="annotation">Janis Rozentāls. “Gaismas pils”. Mets Rīgas Latviešu biedrības priekškaram. 1910.
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (61).jpg' />
                                <p class="annotation">Jānis Roberts Tilbergs. Ilustrācija pasaku grāmatai “Misiņbārdis un stiprais
                                    kalps.” (Rīga, 1913) </p>
                            </div>
                            <div class="next">
                                >
                            </div>
                        </div>


                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
                <div v-if="pop13 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop13=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (49).jpg' />
                                <p class="annotation">Ādams Alksnis. Senlatviešu kauja ar bruņiniekiem. Skice. Ap 1890 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (50).jpg' />
                                <p class="annotation">Arturs Baumanis. Likteņa zirgs. 1887 </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
                <div v-if="pop14 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop14=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (43).jpg' />
                                <p class="annotation">Gustavs Šķilters. “Maziņš biju, neredzēju.” 1903</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px; width:70%; height:auto; margin:auto !important;' src='../assets/images/img (44).jpg' />
                                <p class="annotation">Teodors Zaļkalns. Piemineklis zemkopim Jānim Gaujam Jaunsvirlaukas Jačūnu
                                    kapos. Ap 1910</p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>




            <transition name="fade">
                <div v-if="pop5 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop5=false">
                    </div>
                    <!-- 7-18 -->
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (51).jpg' />
                                <p class="annotation">Jānis Kuga. Dekorāciju mets Raiņa lugas “Uguns un nakts” pirmuzvedumam
                                    Jaunajā
                                    Rīgas teātrī. 1911
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (52).jpg' />
                                <p class="annotation">Skats no Raiņa lugas “Uguns un nakts” 1. cēliena. Pirmuzvedums Jaunajā Rīgas
                                    teātrī.1911. RTMM
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image" style="text-align:center;">
                                <img style='padding:0 5px;display:inline-block;height:660px;width:auto' src='../assets/images/img (53).jpg' />
                                <img style='padding:0 5px;display:inline-block;height:660px;width:auto' src='../assets/images/img (54).jpg' />
                                <p class="annotation">Tija Banga Spīdolas lomā un Ādolfs Kaktiņš Lāčplēša lomā Raiņa lugas “Uguns
                                    un nakts pirmuzvedumā Jaunajā Rīgas teātrī. 1911. RTMM
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>

                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (55).jpg' />
                                <p class="annotation">Raiņa lugas “Pūt, vējiņi” fināla skats. Pirmuzvedums Jaunā Rīgas teātrī 1914.
                                    RTMM</p>
                            </div>

                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (56).jpg' />
                                <p class="annotation">Mirdza Šmithene Baibas lomā Raiņa lugas “Pūt, vējiņi!” pirmuzvedumā Jaunajā
                                    Rīgas teātrī. RTMM</p>
                            </div>

                        </div>

                    </Carousel>

                </div>
            </transition>
            <transition name="fade">
                <div v-if="pop6 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop6=false">
                    </div>

                    <Carousel :items="1" :dots="false">

                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (8).jpg' />
                                <p class="annotation">“Latvju dainu” pirmizdevums Krišjāņa Barona sakārtojumā. 1. burtnīca (Jelgava, 1894)</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (9).jpg' />
                                <p class="annotation">Matīss Siliņš. Latvijas – latviešu zemes karte. 1911</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (57).jpg' />
                                <p class="annotation">Rainis. “Ave, sol!” (1910) </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (58).jpg' />
                                <p class="annotation">Rainis. “Zelta zirgs.” (1910) </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (59).jpg' />
                                <p class="annotation">Andrievs Niedra. “Līduma dūmos.” (Rīga, 1901) </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (60).jpg' />
                                <p class="annotation">Andrievs Niedra. “Zemnieka dēls.” (Pēterburga, 1902) </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (62).jpg' />
                                <p class="annotation">Mākslas un kritikas rakstu krājuma “Zalktis” 1908. gada 1. numurs </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (63).jpg' />
                                <p class="annotation">Jāņa Misiņa bibliotēkas ekslibrs</p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

    </div>
    <!-- angļu valoda -->
    <div v-if="this.language == 2 && this.current == 1" class="slide slide-1" style="position:relative">
            <div  class="img-slider">
                
                <div style="width:100%; height:317px;background:rgba(203,196,192, 1); padding-top:10px;">
                    <div style="position:relative;height:100%;">
                    <Slick :options="slht">
                    

                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (1).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (10).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (11).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (12).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (13).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (14).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (15).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (16).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (17).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (18).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (19).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (2).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (20).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (21).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (22).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (23).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (24).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (25).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (26).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (27).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (28).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (29).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (3).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (30).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (31).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (32).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (33).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (34).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (35).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (36).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (37).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (38).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (39).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (4).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (40).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (41).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (42).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (43).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (44).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (45).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (46).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (47).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (48).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (49).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (5).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (50).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (51).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (52).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (53).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (54).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (55).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (56).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (57).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (58).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (59).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (6).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (60).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (61).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (62).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (63).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (64).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (7).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (8).jpg' /></div>
                            <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (9).jpg' /></div>



                        
                    </Slick>
                    </div>
                </div>
            </div>
            
            
             <div style="width:100%; height:1290px;position:relative" >
                 <transition name="fade">
                 <div v-if="subcat==false">
                     <div style="position:absolute; top:150px; left:250px" @click="pop1=true">
                    <div class="category cat-1 animated pulse infinite slow">
                        
                        <h3>Latvian Ethnographic Exhibition 1896</h3>
                    </div>

                </div>


                <div style="position:absolute; top:530px; left:250px" @click="pop2=true">
                    <div class="category cat-2 animated pulse infinite slow">
                        
                        <h3>III-V Latvian Song Festivals</h3>
                    </div>

                </div>

                <div style="position:absolute; top:900px; left:250px" @click="pop3=true">
                    <div class="category cat-3 animated pulse infinite slow">
                        
                        <h3>Architecture – National Romantic style </h3>
                    </div>

                </div>


                <div style="position:absolute; top:150px; right:250px" @click="subcat=true">
                    <div class="category cat-4 animated pulse infinite slow">
                        
                        <h3>Reflection of national identity in Latvian fine arts</h3>
                    </div>

                </div>

                <div style="position:absolute; top:530px; right:250px" @click="pop5=true">
                    <div class="category cat-5 animated pulse infinite slow">
                        
                        <h3>Heroism and ethical values in Latvian theatre</h3>
                    </div>

                </div>
                <div style="position:absolute; top:900px; right:250px" @click="pop6=true">
                    <div class="category cat-6 animated pulse infinite slow">
                        
                        <h3>Latvian book printing and cartography</h3>
                    </div>

                </div>


                 </div>
                 </transition>
                 <transition name="fade">
                 <div v-if="subcat==true">
                 <div style="position:absolute;top:50px;right:50px;">
                    <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="subcat=false">
                </div>
                <div style="position:absolute; top:150px; left:250px" @click="pop7=true">
                    <div class="category cat-7 animated pulse infinite slow">
                        
                        <h3>IV Exhibition of Latvian Artists</h3>
                    </div>

                </div>


                <div style="position:absolute; top:430px; left:250px" @click="pop8=true">
                    <div class="category cat-8 animated pulse infinite slow">
                        
                        <h3>Portraits of peasants and their activities</h3>
                    </div>

                </div>

                <div style="position:absolute; top:700px; left:250px" @click="pop9=true">
                    <div class="category cat-9 animated pulse infinite slow">
                        
                        <h3>Nature of Latvia</h3>
                    </div>

                </div>


                <div style="position:absolute; top:970px; left:250px" @click="pop10=true">
                    <div class="category cat-10 animated pulse infinite slow">
                        
                        <h3>Hero in Latvian culture</h3>
                    </div>

                </div>

                <div style="position:absolute; top:150px; right:250px" @click="pop11=true">
                    <div class="category cat-11 animated pulse infinite slow">
                        
                        <h3>Modernization of Latvian ornaments</h3>
                    </div>

                </div>
                <div style="position:absolute; top:430px; right:250px" @click="pop12=true">
                    <div class="category cat-12 animated pulse infinite slow">
                        
                        <h3>Folklore and mythology</h3>
                    </div>

                </div>
                <div style="position:absolute; top:700px; right:250px" @click="pop13=true">
                    <div class="category cat-13 animated pulse infinite slow">
                        
                        <h3>Historical genre</h3>
                    </div>

                </div>
                <div style="position:absolute; top:970px; right:250px" @click="pop14=true">
                    <div class="category cat-14 animated pulse infinite slow">
                        
                        <h3>Sculpture</h3>
                    </div>

                </div>
                </div>
                 </transition>
            </div>

            <div style="width:100%; height:342px;overflow:visible">

                <swiper :options="swipperOptions">

                    <swiper-slide>
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:260px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:485px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:710px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:985px" />
                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">
                        <div style="position:absolute; bottom:65px; left:115px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop1 = !tpop1">1886</p>
                                <transition name="fade">
                                    <div v-if="this.tpop1 == true" class="description">The newspaper “Dienas Lapa” (The Daily Page) published in Riga (1886-1905 and 1913-1914), since the beginning of the 1890s the main proclaimer of the ideas of the movement Jaunā strāva (New current)
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:340px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop2 = !tpop2">1888</p>
                                <transition name="fade">
                                    <div v-if="this.tpop2 == true" class="description">III Latvian Song Festival held</div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:565px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop3 = !tpop3">1891</p>
                                <transition name="fade">
                                    <div v-if="this.tpop3 == true" class="description">
                                        <ul>
                                            <li>Rūķis (Elf), a union of Latvian artists established in St Petersburg</li>
                                            <li>Jānis Pliekšāns (poet, later took the pen name Rainis) took the editor’s position of the newspaper “Dienas Lapa” (The Daily Page)</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:785px; width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop4 = !tpop4">1891 – 1903 </p>
                                <transition name="fade">
                                    <div v-if="this.tpop4 == true" class="description two">“Latvian Folk-tales and Legends” in 7 volumes published; compiled by Ansis Lerhs-Puškaitis</div>
                                </transition>

                            </div>
                        </div>


                    </swiper-slide>
                    <swiper-slide>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:180px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:455px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:680px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:905px" />
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">
                        <div style="position:absolute; bottom:65px; left:-20px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop5 = !tpop5">1891 – 1898</p>
                                <transition name="fade">
                                    <div v-if="this.tpop5 == true" class="description two">The first Encyclopaedic Dictionary in the Latvian language published at Jēkabs Dravnieks’ publishing house in Jelgava 
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:255px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop6 = !tpop6">1894 – 1898</p>
                                <transition name="fade">
                                    <div v-if="this.tpop6 == true" class="description two">The first volumes of “Latvju dainas” (Latvian Folksongs) published
                                    </div>
                                </transition>

                            </div>
                        </div>

                        <div style="position:absolute; bottom:65px; left:535px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop7 = !tpop7">1894</p>
                                <transition name="fade">
                                    <div v-if="this.tpop7 == true" class="description">
                                        <ul>
                                            <li>“Materials of Latvian Folk Music” in 6 volumes by Andrejs Jurjāns started to be published, laying the basis for Latvian folk music studies</li>
                                            <li>The first staging of the plays “Vaidelote” (Priestess) and “Zaudētās tiesības” (Lost Rights) at Riga Latvian Theatre</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:760px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop8 = !tpop8">1895</p>
                                <transition name="fade">
                                    <div v-if="this.tpop8 == true" class="description">
                                        <ul>
                                            <li>IV Latvian Song and Music Festival held</li>
                                            <li>“Latviešu valodas mācība” (Latvian Grammar for Schools) by Kārlis Mīlenbahs published</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>


                    </swiper-slide>
                    <swiper-slide>
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:50px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:275px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:500px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:775px" />
                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">
                        <div style="position:absolute; bottom:65px; left:-95px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop9 = !tpop9">1896</p>
                                <transition name="fade">
                                    <div v-if="this.tpop9 == true" class="description">Latvian Ethnographic Exhibition in Riga opened</div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:130px; width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop10 = !tpop10">1899</p>
                                <transition name="fade">
                                    <div v-if="this.tpop10 == true" class="description">the choral song “Gaismas pils” (The Palace of Light) composed by Jāzeps Vītols (lyrics by Auseklis)</div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:355px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop11 = !tpop11">1902</p>
                                <transition name="fade">
                                    <div v-if="this.tpop11 == true" class="description">
                                        <ul>
                                            <li>The first staging of the play “Skroderdienas Silmačos” (Days of Tailoring at Silmači) by Rūdolfs Blaumanis at Riga Latvian Theatre</li>
                                            <li>Folk song arrangements “Birzēs i norās” (In Groves and Fields) by Emilis Melngailis started to be published</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:575px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop12 = !tpop12">1903 – 1915</p>
                                <transition name="fade">
                                    <div v-if="this.tpop12 == true" class="description two">
                                        The remaining five volumes of “Latvju dainas” (Latvian Folksongs) published
                                    </div>
                                </transition>

                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:-75px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:150px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:375px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:600px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:825px" />
                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">

                        <div style="position:absolute; bottom:65px; left:-220px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop13 = !tpop13">1903</p>
                                <transition name="fade">
                                    <div v-if="this.tpop13 == true" class="description">
                                        <ul>
                                            <li>The choral song “Karaļmeita” (The King’s Daughter) composed by Jāzeps Vītols (lyrics by Rainis)</li>
                                            <li>The first staging of the play “Sprīdītis” (The Tale of Sprīdītis) by Anna Brigadere at Riga Latvian Theatre</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:5px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop14 = !tpop14">1904</p>
                                <transition name="fade">
                                    <div v-if="this.tpop14 == true" class="description">
                                        <ul>
                                            <li>The choral song “Senatne” (Yesteryear) composed by Emīls Dārziņš (lyrics by Rainis)/li>
                                            <li>The first staging of the play “The Indrāni” by Rūdolfs Blaumanis at Riga Latvian Theatre</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:230px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop15 = !tpop15">1905</p>
                                <transition name="fade">
                                    <div v-if="this.tpop15 == true" class="description">
                                        <ul>
                                            <li>The first staging of the play “Sidraba šķidrauts” (The Silver Veil) by Aspazija at New Riga Latvian Theatre</li>
                                            <li>History section of Sciences commission established at Riga Latvian Society</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:455px; width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop16 = !tpop16">1906</p>
                                <transition name="fade">
                                    <div v-if="this.tpop16 == true" class="description">
                                        <ul>
                                            <li>The City Art Museum (today: Latvian National Museum of Art) opened in Riga</li>
                                            <li>Latvian Photographic Society founded by Mārtiņš Buclers</li>
                                            <li>The Library of Jānis Misiņš opened; the oldest and most complete collection of books in the Latvian language</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:680px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop17 = !tpop17">1908</p>
                                <transition name="fade">
                                    <div v-if="this.tpop17 == true" class="description">
                                        <ul>
                                            <li>The Orthography commission established at Riga Latvian Society and under the guidance of the linguists Kārlis Mīlenbahs and Jānis Endzelīns laid down the principles of modern Latvian orthography</li>
                                            <li>New Riga Theatre founded</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>


                    </swiper-slide>

                    <swiper-slide>
                        <div style="width:100%;height:100%;" @click="closePop()">
                        </div>
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:-30px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:200px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:420px" />
                        <img src="../assets/zimes/arrow.png" style="position:absolute;bottom:48px;left:645px" />

                        <hr style="position:absolute; bottom:60px;width:100%; border:none; background:#605F5F; height:4px;">
                        <div style="position:absolute; bottom:65px; left:-175px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop18 = !tpop18">1909</p>
                                <transition name="fade">
                                    <div v-if="this.tpop18 == true" class="description">
                                        <ul>
                                            <li>The new building of Riga Latvian Society opened</li>
                                            <li>The drama courses of J. Duburs and Zeltmatis opened; the first professional acting classes in the history of Latvian theatre </li>
                                            <li>The poetry collection “Klusā grāmata” (The Hushed Book) by Rainis</li>
                                            <li>The first staging of the play “Zelta zirgs” (The Golden Horse) by Rainis at New Riga Theatre</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:50px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop19 = !tpop19">1910</p>
                                <transition name="fade">
                                    <div v-if="this.tpop19 == true" class="description">
                                        <ul>
                                            <li>V Latvian Song Festival held</li>
                                            <li>The first extensive exhibition of Latvian fine art organized</li>
                                            <li>The poetry collection “Ave sol!” by Rainis published</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:275px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop20 = !tpop20">1911</p>
                                <transition name="fade">
                                    <div v-if="this.tpop20 == true" class="description">
                                        <ul>
                                            <li>Latvian Art Promotion Society established</li>
                                            <li>The first permanent Latvian ballet troupe by the ballet master Mārtiņš Kauliņš established</li>
                                            <li>The first staging of the play “Uguns un nakts” (Fire and Night) by Rainis at New Riga Theatre</li>
                                            <li>The daily paper “Jaunākās Ziņas” (The Latest News) published; in later years the largest Latvian periodical (publishers Antons and Emīlija Benjamiņi)</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>
                        </div>
                        <div style="position:absolute; bottom:65px; left:500px;width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop21 = !tpop21">1912</p>
                                <transition name="fade">
                                    <div v-if="this.tpop21 == true" class="description">
                                        <ul>
                                            <li>The first staging of the play “Indulis and Ārija” by Rainis at New Riga Theatre</li>
                                            <li>The Latvian Opera founded</li>
                                        </ul>
                                    </div>
                                </transition>

                            </div>

                        </div>
                        <div style="position:absolute; bottom:65px; left:725px; width:150px;z-index:10;">
                            <div class="text" style="position:absolute; top:-23px; margin:auto !important; text-align:center">
                                <p class="year animated pulse infinite" @click="tpop22 = !tpop22">1914</p>
                                <transition name="fade">
                                    <div v-if="this.tpop22 == true" class="description">
                                        The first staging of the play “Pūt, vējiņi!” (Blow, the Winds!) by Rainis at New Riga Theatre
                                    </div>
                                </transition>

                            </div>
                        </div>



                    </swiper-slide>



                </swiper>
            </div>

            <transition name="fade">
                <div v-if="pop1 == true" class="pop-slider" style="z-index:50;position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;" >
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop1=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                            <div>
                                <div class="prev">
                                    
                                </div>
                                <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (1).jpg' />
                                <p class="annotation">Poster of the Latvian Ethnographic Exhibition. 1896 </p>
                                </div>
                                <div class="next">
                                    <img src="../assets/zimes/next.png" alt="">
                                </div>
                            </div>
                            <div >
                                <div class="prev">
                                    <img src="../assets/zimes/prev.png" alt="">
                                </div>
                                <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (2).jpg' />
                                <p class="annotation">Konstantīns Pēkšēns. Structure of the Latvian Ethnographic Exhibition. 1896 </p>
                                </div>
                                <div class="next">
                                    
                                </div>
                            </div>
                            
                    </Carousel>

                </div>
            </transition>


            <transition name="fade">
                <div v-if="pop2 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop2=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">
                                
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (3).jpg' />
                                <p class="annotation">The mixed choir of Riga Latvian Singing Society, the main prize winner at the Third Latvian Song Festival. 1888
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>

                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (4).jpg' />
                                <p class="annotation">Rihards Zariņš. Poster of the Fourth Latvian Song and Music Festival. 1895
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>

                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (5).jpg' />
                                <p class="annotation">View of the structure of the Fifth Latvian Song Festival. Architect Ernests Pole. 1910. LNVM</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (6).jpg' />
                                <p class="annotation"> </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (7).jpg' />
                                <p class="annotation">Interior view of the structure of the Fifth Latvian Song Festival. Architect Ernests Pole. 1910. LNVM </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>
                    </Carousel>

                </div>
            </transition>
       
    


            <transition name="fade">
                <div v-if="pop3 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop3=false">
                    </div>
                    <!-- 7-18 -->
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (10).jpg' />
                                <p class="annotation">Konstantīns Pēkšēns and Eižens Laube. Residential building in Riga, 26 Aleksandra Čaka street. Beginning of the 20th century</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:10px 5px;' src='../assets/images/img (11).jpg' />

                                <img style='padding:0 5px;' src='../assets/images/img (12).jpg' />

                                <p class="annotation">Konstantīns Pēkšēns and Eižens Laube. Residential building in Riga, 26 Aleksandra Čaka street. Elements </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px; width:50%;margin:auto !important' src='../assets/images/img (13).jpg' />
                                <p class="annotation">Konstantīns Pēkšēns and Eižens Laube. Atis Ķeniņš Gymnasium, 15 Tērbatas street. 1905 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (14).jpg' />
                                <p class="annotation">Eižens Laube. Residential building, 47 Brīvības street. 1908 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (15).jpg' />
                                <p class="annotation">Eižens Laube. Residential building, 47 Brīvības street. 1908. Elements. RJC. Photo by Marika Vanaga  </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (16).jpg' />
                                <p class="annotation">Eižens Laube. Residential building, 37 Brīvības street. 1908. Elements  </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (17).jpg' />
                                <p class="annotation">Eižens Laube. Residential building, 62 Brīvības street. 1908. Elements. RJC. Photo by Marika Vanaga  </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (18).jpg' />
                                <p class="annotation">Eižens Laube. Residential building, 62 Brīvības street. 1908 (different year on the portal – 1909).  Elements. Museum “Riga Art Nouveau Centre”. Photo by Marika Vanaga </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (19).jpg' />
                                <p class="annotation">Eižens Laube. Residential building, 23/25 Ģertrūdes street. 1909</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (20).jpg' />
                                <p class="annotation">Aleksandrs Vanags. Residential building in Riga, 69 Krišjāņa Valdemāra street. 1909</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (21).jpg' />
                                <p class="annotation">Aleksandrs Vanags. Residential building in Riga, 69 Krišjāņa Valdemāra street. Elements. Museum “Riga Art Nouveau Centre”. Photo by Romvalds Salcevičs</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (22).jpg' />
                                <p class="annotation">Ernests Pole and Eižens Laube. The building of Riga Latvian Society. 1909</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (23).jpg' />
                                <p class="annotation">Janis Rozentāls. “Pērkons, Potrimps and Pīkols” (The names of allegorical images in Latvian tales).  Central decorative panel on the Riga Latvian Society building. 1910.</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (24).jpg' />
                                <p class="annotation">Janis Rozentāls. “The Greeting of the Sun”. Decorative panel on the left risalit of the Riga Latvian Society building. 1910</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (25).jpg' />
                                <p class="annotation">Janis Rozentāls. “At the spring.” Decorative panel on the right risalit of the Riga Latvian Society building. 1910</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (26).jpg' />
                                <p class="annotation">Augusts Malvess. Society House in Sigulda (“the Switzerland of Vidzeme”). 1911 </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>
                    </Carousel>

                </div>
            </transition>
            

            <!-- subpops -->
            <transition name="fade">
            <div v-if="pop7 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;" >
                <div style="position:absolute;top:50px;right:50px; z-index:999">
                    <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop7=false">
                </div>
                <Carousel :items="1" :dots="false">
                        <div >
                            <img style='padding:0 5px;' src='../assets/images/img (45).jpg' />
                            <p class="annotation">Janis Rozentāls. Poster for IV Latvian Artists Exhibition. 1914 </p>
                        </div>
                       
                </Carousel>

            </div>
            </transition>

            <transition name="fade">
                <div v-if="pop8 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop8=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (27).jpg' />
                                <p class="annotation">Ādams Alksnis. “Father’s portrait.” Around 1890 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (28).jpg' />
                                <p class="annotation">Ādams Alksnis. Peasant portraits for the Latvian Ethnographic Exhibition 1896 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (29).jpg' />
                                <p class="annotation">Janis Rozentāls. “Shepherdess.” 1896 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (30).jpg' />
                                <p class="annotation">Janis Rozentāls. “Mowing time.” 1903  </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (31).jpg' />
                                <p class="annotation">Janis Rozentāls. “From the meadow.” 1903 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (32).jpg' />
                                <p class="annotation">Janis Rozentāls. “Kneader.” 1896  </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (33).jpg' />
                                <p class="annotation">Teodors Ūders. “Morning.” Around 1910 </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
                <div v-if="pop9 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop9=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (34).jpg' />
                                <p class="annotation">Vilhelms Purvītis. “Early spring.” 1898-1899 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (35).jpg' />
                                <p class="annotation">Janis Rozentāls. “Spring landscape. Sigulda.” 1913 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (36).jpg' />
                                <p class="annotation">Vilhelms Purvītis. “Waters in spring”" (“Maestoso”). 1910 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>

                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (38).jpg' />
                                <p class="annotation">Vilhelms Purvītis. “Autumn sun.” Around 1909 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (39).jpg' />
                                <p class="annotation">Vilhelms Purvītis. “Landscape with birch trees.” Around 1910 </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
                <div v-if="pop10 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop10=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (40).jpg' />
                                <p class="annotation">Jānis Krēsliņš. Lāčplēsis (Bear-slayer: legendary Latvian hero). Illustration in the book “Legends from the Maliena Region of Latvia”. 1891 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>

                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (41).jpg' />
                                <p class="annotation">Rihards Zariņš. Kurbads the Hero and nine-headed devil. From the cycle “The Wood Rustles”. 1908-1911. 
                                </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
            <div v-if="pop11 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;" >
                <div style="position:absolute;top:50px;right:50px; z-index:999">
                    <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop11=false">
                </div>
                <Carousel :items="1" :dots="false">
                        <div >
                            <img style='padding:0 5px;' src='../assets/images/img (42).jpg' />
                            <p class="annotation">Jūlijs Madernieks. Ornaments and samples. Around 1913 </p>
                        </div>
                       
                </Carousel>

            </div>
            </transition>

            <transition name="fade">
                <div v-if="pop12 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop12=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (37).jpg' />
                                <p class="annotation">Johans Valters. “Spring" (“Little orphan”).  1907 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (46).jpg' />
                                <p class="annotation">Janis Rozentāls. “Black snake grinding flour.” 1903 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (47).jpg' />
                                <p class="annotation">Janis Rozentāls. “The Saga.” 1899 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (48).jpg' />
                                <p class="annotation">Janis Rozentāls. “The palace of light”. Sketch of the curtain for Riga Latvian Society. 1910
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (61).jpg' />
                                <p class="annotation">Jānis Roberts Tilbergs. Illustration in the book of fairy-tales “Misiņbārdis and the Strong Servant.” (Riga, 1913) </p>
                            </div>
                            <div class="next">
                                >
                            </div>
                        </div>


                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
                <div v-if="pop13 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop13=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (49).jpg' />
                                <p class="annotation">Ādams Alksnis. Ancient Latvians fighting against knights. Sketch. About 1890 </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (50).jpg' />
                                <p class="annotation">Arturs Baumanis. The horse of destiny. 1887 </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

            <transition name="fade">
                <div v-if="pop14 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop14=false">
                    </div>
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (43).jpg' />
                                <p class="annotation">Gustavs Šķilters. “I was little, I didn’t see” (A theme from the Latvian folk song). 1903  </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px; width:70%; height:auto; margin:auto !important;' src='../assets/images/img (44).jpg' />
                                <p class="annotation">Teodors Zaļkalns. Monument to the farmer Jānis Gauja in Jačūnu cemetery at Jaunsvirlauka. Around 1910 </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>




            <transition name="fade">
                <div v-if="pop5 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop5=false">
                    </div>
                    <!-- 7-18 -->
                    <Carousel :items="1" :dots="false">
                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (51).jpg' />
                                <p class="annotation">Jānis Kuga. Sketch of the stage design for the first staging of the play “Uguns un nakts” (Fire and Night) by Rainis at New Riga Theatre.1911
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (52).jpg' />
                                <p class="annotation">Scene from Act 1 of the play “Uguns un nakts” (Fire and Night) by Rainis at New Riga Theatre. 1911. Literature and Music Museum
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image" style="text-align:center;">
                                <img style='padding:0 5px;display:inline-block;height:660px;width:auto' src='../assets/images/img (53).jpg' />
                                <img style='padding:0 5px;display:inline-block;height:660px;width:auto' src='../assets/images/img (54).jpg' />
                                <p class="annotation">Tija Banga in the role of Spīdola and Ādolfs Kaktiņš in the role of Lāčplēsis in the play “Uguns un nakts” (Fire and Night) by Rainis at New Riga Theatre. 1911. Literature and Music Museum
                                </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>

                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (55).jpg' />
                                <p class="annotation">The final scene of the play “Pūt, vējiņi!” (Blow, the Winds!) by Rainis at New Riga Theatre. 1914. Literature and Music Museum</p>
                            </div>

                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (56).jpg' />
                                <p class="annotation">Mirdza Šmithene in the role of Baiba in the play “Pūt, vējiņi!” (Blow, the Winds!) by Rainis at New Riga Theatre. 1914. Literature and Music Museum</p>
                            </div>

                        </div>

                    </Carousel>

                </div>
            </transition>
            <transition name="fade">
                <div v-if="pop6 == true" class="pop-slider" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8); padding:50px;">
                    <div style="position:absolute;top:50px;right:50px; z-index:999">
                        <img src="../assets/zimes/close.png" style="width:50px" alt="" @click="pop6=false">
                    </div>

                    <Carousel :items="1" :dots="false">

                        <div>
                            <div class="prev">

                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (8).jpg' />
                                <p class="annotation">Latvian folk songs (“Latvju dainas”). Collected by Krišjānis Barons. The first edition.  I part (Jelgava, 1894)</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (9).jpg' />
                                <p class="annotation">Matīss Siliņš. The map of Latvia – the land of Latvian people. 1911</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (57).jpg' />
                                <p class="annotation">Rainis. “Ave, sol!” (1910)</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (58).jpg' />
                                <p class="annotation">Rainis. “The Golden Horse.” (1910)</p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (59).jpg' />
                                <p class="annotation">Andrievs Niedra. “The Smoke from the Clearing.” (Riga, 1901) </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (60).jpg' />
                                <p class="annotation">Andrievs Niedra. “Peasant’s Son.” (Petersburg, 1902) </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (62).jpg' />
                                <p class="annotation">Collection of articles on art and art criticism “Zalktis” (Grass snake), No.1, 1908  </p>
                            </div>
                            <div class="next">
                                <img src="../assets/zimes/next.png" alt="">
                            </div>
                        </div>
                        <div>
                            <div class="prev">
                                <img src="../assets/zimes/prev.png" alt="">
                            </div>
                            <div class="image">
                                <img style='padding:0 5px;' src='../assets/images/img (63).jpg' />
                                <p class="annotation">Exlibris of Jānis Misiņš library </p>
                            </div>
                            <div class="next">

                            </div>
                        </div>

                    </Carousel>

                </div>
            </transition>

    </div>
<Menu />



        <!-- image cache -->
        <div style="display:none;z-index:-999;">
                    <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (1).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (10).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (11).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (12).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (13).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (14).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (15).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (16).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (17).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (18).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (19).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (2).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (20).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (21).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (22).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (23).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (24).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (25).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (26).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (27).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (28).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (29).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (3).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (30).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (31).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (32).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (33).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (34).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (35).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (36).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (37).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (38).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (39).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (4).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (40).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (41).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (42).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (43).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (44).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (45).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (46).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (47).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (48).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (49).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (5).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (50).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (51).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (52).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (53).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (54).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (55).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (56).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (57).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (58).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (59).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (6).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (60).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (61).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (62).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (63).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (64).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (7).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (8).jpg' /></div>
                                <div><img style='max-height:297px;width:auto;padding:0 5px;' src='../assets/images/img (9).jpg' /></div>
        </div>



</div>
</template>
<script>
import Menu from "./Menu.vue";
import Slick from "./Slick.vue";
import Carousel from "v-owl-carousel";
import { swiper, swiperSlide } from 'vue-awesome-swiper'




export default
{
components:
{
    Menu,
    Slick,
   swiper,
   swiperSlide,
    Carousel

},
data: function()
{
    return{
        swipperOptions:
        {
            freeMode: true,
            height:345,
            grabCursor:true,
            speed:100
            
            
        },
        language:1,
        current:0,
        pop1:false,
        pop2:false,
        pop3:false,
        pop4:false,
        pop5:false,
        pop6:false,
        pop7:false,
        pop8:false,
        pop9:false,
        pop10:false,
        pop11:false,
        pop12:false,
        pop13:false,
        pop14:false,
        
        
        tpop1:false,
        tpop2:false,
        tpop3:false,
        tpop4:false,
        tpop5:false,
        tpop6:false,
        tpop7:false,
        tpop8:false,
        tpop9:false,
        tpop10:false,
        tpop11:false,
        tpop12:false,
        tpop13:false,
        tpop14:false,
        tpop15:false,
        tpop16:false,
        tpop17:false,
        tpop18:false,
        tpop19:false,
        tpop20:false,
        tpop21:false,
        tpop22:false,
        

        subcat:false,


        max:15,
        slv: {
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: true,
                verticalSwiping: true,
                touchThreshold: 200,
                infinite: false,
                arrows: false,
                speed:300,
            },
        slh: {
                slidesToShow: 1,
                slidesToScroll: 1,
                touchThreshold: 700,
                swipeToSlide:true,
                speed:300,
                infinite: false,
                arrows: false
            },
            slht: {
                slidesToShow: 3,
                slidesToScroll: 1,
                waitForAnimate : false, pauseOnFocus : false, pauseOnHover : false, swipe : false,
                speed:1000,
                infinite: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 500,
                centerMode: true,
                variableWidth: true,
                
                
            },
      
    }
},
methods:{
slide(n) {
      this.current = n;
      this.count();
    },
    count() {
      this.$eventHub.$emit("slide-changed", this.current);
    },
        subOpen()
        {
            this.$eventHub.$emit("subOpen", this.current);
        },
        subClose()
        {
            this.$eventHub.$emit("subClose", this.current);
        },
        closePop()
        {
            this.tpop1=false;
            this.tpop2=false;
            this.tpop3=false;
            this.tpop4=false;
            this.tpop5=false;
            this.tpop6=false;
            this.tpop7=false;
            this.tpop8=false;
            this.tpop9=false;
            this.tpop10=false;
            this.tpop11=false;
            this.tpop12=false;
            this.tpop13=false;
            this.tpop14=false;
            this.tpop15=false;
            this.tpop16=false;
            this.tpop17=false;
            this.tpop18=false;
            this.tpop19=false;
            this.tpop20=false;
            this.tpop21=false;
            this.tpop22=false;
          
        }

},

created()
{
    this.$eventHub.$on('slider-move', function()
    {
        console.log('aaaa');
    });
     this.$eventHub.$on("next-slide", slide => {
        this.pop1=false;
        this.pop2=false;
        this.pop3=false;
        this.pop4=false;
       
      if (this.current !== this.max - 1) {
        this.current++;
        this.count();
      }
      if (this.current == this.max-1 || this.current == 11 )
      {
        this.slide(1);
      }
    });
    this.$eventHub.$on("home-slide", slide => {
       
        this.pop1=false;
        this.pop2=false;
        this.pop3=false;
        this.pop4=false;
        this.current = 0;
    });
    this.$eventHub.$on("prev-slide", slide => {
        
        this.pop1=false;
        this.pop2=false;
        this.pop3=false;
        this.pop4=false;
      if (this.current !== 0) {
        this.current--;
        this.count();
      }
      if ( this.current == 11 )
      {
        this.slide(1);
      }
      
    });
    this.$eventHub.$on("slide", slide => {
       
        this.pop1=false;
        this.pop2=false;
        this.pop3=false;
        this.pop4=false;
        this.pop5=false;
        this.pop6=false;
        this.pop7=false;
        this.pop8=false;
        this.pop9=false;
        this.pop10=false;
        this.pop11=false;
        this.pop12=false;
        this.pop13=false;
        this.pop14=false;
        
        
        this.tpop1=false;
        this.tpop2=false;
        this.tpop3=false;
        this.tpop4=false;
        this.tpop5=false;
        this.tpop6=false;
        this.tpop7=false;
        this.tpop8=false;
        this.tpop9=false;
        this.tpop10=false;
        this.tpop11=false;
        this.tpop12=false;
        this.tpop13=false;
        this.tpop14=false;
        this.tpop15=false;
        this.tpop16=false;
        this.tpop17=false;
        this.tpop18=false;
        this.tpop19=false;
        this.tpop20=false;
        this.tpop21=false;
        this.tpop22=false;
        

        this.subcat=false;

       
        this.current = slide;
        this.count();
      
      
    });
    this.$eventHub.$on("language", language => {
      
        this.language = language;
        
      
      
    });
}
}
</script>
<style lang="scss">
.pop-slider{
    z-index:50;
    .image{
        width:90%;
        display:inline-block;
        vertical-align: middle;
    }
    .next{
        display:inline-block;
        width:4%;
        padding-right:5px;
        vertical-align: middle;
    }
    .prev{
        display:inline-block;
        width:4%;
        padding-left:5px;
        vertical-align: middle;
    }
}
.swiper-container{
    overflow:visible !important;
}
.swiper-slide
{
   height:200px !important;
   
}
.category{
    
    width:220px;
    height:220px;
    border:2px solid rgba(203,196,192, 1);
    border-radius:150px;
   
    background-size:cover;
    display:flex;
    align-items:center;
    -webkit-font-smoothing: antialiased;
    h3{
        margin:auto !important;
        padding:24px;
        text-align:center;
        font-size:19px;
        font-family:'AlmiraBold';
        color:rgba(203,196,192, 1);
        -webkit-font-smoothing: antialiased;
        
        
    }
    

    
    
   
}
.year{
    background:#fff; color:#605F5F; font-weight:bold; padding:15px; border-radius:20px;
    font-family:'Century Schoolbook';
   
}
.description{
    &.two{
        left:-67px;
        width:260px;
    }
    ul
    {
        padding-left:15px;
        list-style-type:disc;
        
    }
    font-family: 'AlmiraRegular';
    font-size:14px;
    position:absolute;
    text-align:justify;
    left:-73px; 
    bottom:70px;
    width:210px; 
    background:rgba(255,255,255,.80);
    padding:10px;
    overflow:visible;
    
}
.cat-1{
    background-image: linear-gradient(rgba(0,0,0, .7),rgba(0,0,0, .7)), url('../assets/images/img (2).jpg');
}
.cat-2{
    background-image: linear-gradient(rgba(0,0,0, .7),rgba(0,0,0, .7)), url('../assets/images/img (5).jpg');
}
.cat-3{
    background-image: linear-gradient(rgba(0,0,0, .7),rgba(0,0,0, .7)), url('../assets/images/img (17).jpg');
}
.cat-4{
    background-image: linear-gradient(rgba(0,0,0, .7),rgba(0,0,0, .7)), url('../assets/images/img (32).jpg');
}
.cat-5{
    background-image: linear-gradient(rgba(0,0,0, .7),rgba(0,0,0, .7)), url('../assets/images/img (51).jpg');
}
.cat-6{
    background-image: linear-gradient(rgba(0,0,0, .7),rgba(0,0,0, .7)), url('../assets/images/img (9).jpg');
}

.cat-7, .cat-8, .cat-9, .cat-10, .cat-11, .cat-12,.cat-12,.cat-13, .cat-14
{
    h3{
            color:rgba(255,255,255,.95);
        }
}

.cat-7{    
    background-image: linear-gradient(rgba(171,122,43,.75),rgba(171,122,43,.75)), url('../assets/images/img (45).jpg');
}
.cat-8{
    background-image: linear-gradient(rgba(171,122,43,.75),rgba(171,122,43,.75)), url('../assets/images/img (29).jpg');
}


.cat-9{
    background-image: linear-gradient(rgba(171,122,43,.75),rgba(171,122,43,.75)), url('../assets/images/img (36).jpg');
}
.cat-10{
    background-image: linear-gradient(rgba(171,122,43,.75),rgba(171,122,43,.75)), url('../assets/images/img (40).jpg');
}
.cat-11{
    background-image: linear-gradient(rgba(171,122,43,.75),rgba(171,122,43,.75)), url('../assets/images/img (42).jpg');
}
.cat-12{
    background-image: linear-gradient(rgba(171,122,43,.75),rgba(171,122,43,.75)), url('../assets/images/img (47).jpg');
}
.cat-13{
    background-image: linear-gradient(rgba(171,122,43,.75),rgba(171,122,43,.75)), url('../assets/images/img (50).jpg');
}
.cat-14{
    background-image: linear-gradient(rgba(171,122,43,.75),rgba(171,122,43,.75)), url('../assets/images/img (43).jpg');
}
.pop{
    opacity:0 !important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.owl-stage-outer {
	position: relative;
	height: 1820px;
}
 .owl-stage {
	position: relative;
	height: 1820px;
}
.owl-carousel .owl-stage {
  display: flex;
  align-items: center;
}
.img-slider{
    transition:all .3s;
    opacity:1;
    img{
        opacity:.6;
        filter:grayscale(.7);
        transition:all 1s;
    }
    div.slick-center{
        img{
            filter:grayscale(0);
            opacity:1;
        }
    }
}
.citats-bef
{
    margin-bottom:20px !important;
    position:relative;
    &:before{
    content: "";
    position:absolute;
    top:-3px;
    width:25px;
    height:20px;
    background:url('../assets/zimes/top-qoutes.png');
    background-repeat:no-repeat;
    }
  }
  .citats-aft {
      margin-top:20px !important;
      position:relative;
    &:after{
    content:"";
    position:absolute;
    width:25px;
    height:20px;
    background:url('../assets/zimes/bottom-qoutes.png');
    background-repeat:no-repeat;
    bottom:5px;
    right:0px;
    }
  }

.citats{
    position:relative;
    padding-top:20px;
    padding-bottom:20px;
&::before {
    
    content: "";
    position:absolute;
    top:-3px;
    width:25px;
    height:20px;
    background:url('../assets/zimes/top-qoutes.png');
    background-repeat:no-repeat;
  }
  &::after {
    content:"";
    position:absolute;
    width:25px;
    height:20px;
    background:url('../assets/zimes/bottom-qoutes.png');
    background-repeat:no-repeat;
    bottom:5px;
    right:0px;
  }
}
.submenus
{
    .nauda{
        hr
        {
            
            width:70%;
            margin:20px auto !important;
            background:white;
            border:none;
            height:3px;
        }
    }
    h3.nod
    {
        font-size:30px;
        text-align:center;
        font-family:'Century Schoolbook';
        color:rgb(91,91,91);
        padding:10px 0px 5px 0px;
    }
    .emp
    {
        font-family:'Century Schoolbook';
        color:rgb(91,91,91);
        font-style:italic;
        font-size:18px;
        border-bottom: 2px dotted #fff;


    }
    
    h2
    {
        font-size:20px;
        font-family:'AlmiraRegular';
        color:rgb(43,42,42);
        padding:5px 0px;
    }
    .subslide
    {
        padding:70px;
        padding-top:50px
    }
}
.hidden
{
    visibility: hidden;
}
.justify{
    text-align:justify;
}
.dinline{
    display:inline-block;
}
.center{
    text-align:center;
}
.m-auto{
    margin:auto !important;
}
.p-10{
    padding:10px;
}

.p-15{
    padding:15px;
}
.p-20{
    padding:20px;
}

.pt-10{
    padding-top:10px;
}

.pt-15{
    padding-top:15px;
}
.pt-20{
    padding-top:20px;
}

.pb-10{
    padding-bottom:10px;
}

.pb-15{
    padding-bottom:15px;
}
.pb-20{
    padding-bottom:20px;
}

.f14{
font-size:14px !important;
}
.f16{
font-size:16px !important;    
}
.f18{
 font-size:18px !important;   
}
.f20{
 font-size:20px !important;   
}
.f22{
 font-size:20px !important;   
}
.f24{
  font-size:24px !important;  
}
.century{
    font-family:'Century Schoolbook';
    color:rgb(43,42,41);
}
.almira{
    font-family:'AlmiraRegular';
    color:rgb(43,42,41);
}
.bold{
    font-weight:bold;
}

.annotation{
    font-family: 'AlmiraRegular';
    color:rgb(255,255,255);
    text-align:center;
    padding-top:5px;
    font-weight:600;
    font-size:18px;
}

.text{
    font-family: 'AlmiraRegular';
    color:rgb(43,42,41);
    font-size:18px;
    font-weight:200;
}
img{
    max-width:100%;
}
.title{
    padding-top:20px;
    font-family:'Century Schoolbook';
    font-size:30px;
    text-align:center;
    font-weight:bold;
    color:rgb(43,42,41);
    text-transform: uppercase;
}
.subtitle{
    font-family:'Century Schoolbook';
    font-size:20px;
    text-align:center;
    text-transform: uppercase;
    color:rgb(43,42,41);
    padding-top:50px;
}

.slick-vertical > .slick-list {
  height: 100% !important;
  .slick-slide {
    height:1556px !important;
  }
  
}
.slick-horizontal{
&.slick-slide {
    height: 1680px !important;
  }
}

  .slick-vertical .slick-slide
  {
      border:0px !important;
  }

.slide{
    height:1920px;
    width:1080px;
    .content{
        position:absolute;
        
        left:78px;
        top:121px;
        height:1671px;
        width:924px;
        overflow:hidden;
    }
}

.slide-1{
    background:linear-gradient(
      rgba(255, 255, 255, 0.2), 
      rgba(255, 255, 255, 0.2)
    ),
    url('../assets/images/img (64).jpg');
    background-size:cover;
}

.home-lv 
{
    background:url('../assets/images/img (64).jpg');
    background-size:cover;
}
.home-arrow {
  position: absolute;
  top: 881px;
  left:808px;
  z-index: 2;
  img{
      width: 240px !important;
      height: 240px !important;
  }
}
.home-box
{
    position:absolute;
    background-image: linear-gradient(to right, rgba(203,196,192,1) , rgba(203,196,192,.7));
   
    top:1048px;
    left:212px;
    width:711px;
    height:113px;

}
.home-text{
    color:rgb(43,42,41);
    font-size:30px;
    font-weight:bold;
    font-family:'Century Schoolbook';
    padding:20px;
}
</style>